const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunnelLvl5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 344.23 91.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.67,77.68s-24.23,10.64-50.55,10.64c-25.51,0-49.47-10.64-49.47-10.64l-14.76-63s32.31,11.14,64.28,11.14c30.89,0,64.17-11,64.17-11Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M172,3.27c-38.4,0-64.14,11.4-64.14,11.4S137.58,26,172.3,26c33,0,64-11.14,64-11.14A191.7,191.7,0,0,0,172,3.27Z",
    style: {
      fill: "#90b8c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.67,77.68s-24.23,10.64-50.55,10.64c-25.51,0-49.47-10.64-49.47-10.64l-14.76-63s32.31,11.14,64.28,11.14c30.89,0,64.17-11,64.17-11Z",
    style: {
      fill: "#bdddeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "142.7 85.99 128.44 84.39 115.22 15.01 134 17.5 142.7 85.99",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.44 85.99 226.57 80.06 241.15 12.57 213.14 17.5 204.44 85.99",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnelLvl5);
export default __webpack_public_path__ + "static/media/funnel-lvl5.1402d85276047a0bc469684430b3f993.svg";
export { ForwardRef as ReactComponent };